/**
 * RecipientHealthBadge
 * Color-coded health tier badge: green (healthy), amber (degraded), red (quarantined).
 */

export type RecipientHealthTier = 'healthy' | 'degraded' | 'quarantined';

interface RecipientHealthBadgeProps {
  tier: RecipientHealthTier;
  className?: string;
}

const tierConfig: Record<
  RecipientHealthTier,
  { label: string; className: string }
> = {
  healthy: {
    label: 'Healthy',
    className: 'bg-success/10 text-success border border-success/30',
  },
  degraded: {
    label: 'Degraded',
    className: 'bg-warning/10 text-warning border border-warning/30',
  },
  quarantined: {
    label: 'Quarantined',
    className: 'bg-destructive/10 text-destructive border border-destructive/30',
  },
};

export function RecipientHealthBadge({
  tier,
  className = '',
}: RecipientHealthBadgeProps) {
  const config = tierConfig[tier] ?? tierConfig.healthy;
  return (
    <span
      data-testid={`recipient-health-badge-${tier}`}
      className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${config.className} ${className}`}
      aria-label={`Health tier: ${config.label}`}
    >
      {config.label}
    </span>
  );
}
